import React from 'react';
import { Helmet } from 'react-helmet-async';

// Schema markup component for dietitian business
const BusinessSchema = () => {
  const businessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Diyetisyen Nihal Kamış",
    "image": "https://www.nihalkamis.com/assets/placeholder-dietitian.png",
    "email": "info@nihalkamis.com",
    "telephone": "+90-XXX-XXX-XX-XX", // Placeholder - add actual phone
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Placeholder address",
      "addressLocality": "İstanbul",
      "addressRegion": "Marmara",
      "postalCode": "34XXX",
      "addressCountry": "TR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 41.0082, // Istanbul coordinates
      "longitude": 28.9784
    },
    "url": "https://www.nihalkamis.com",
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "18:00"
      }
    ],
    "areaServed": [
      {
        "@type": "City",
        "name": "İstanbul"
      }
    ],
    "serviceType": ["Diet Counseling", "Nutrition Planning", "Weight Management"],
    "providedService": [
      {
        "@type": "Service",
        "name": "Kişiye Özgü Diyet Plan Programı",
        "offers": {
          "@type": "Offer",
          "priceSpecification": {
            "@type": "PriceSpecification",
            "priceCurrency": "TRY"
          }
        }
      },
      {
        "@type": "Service",
        "name": "Kilo Yönetimi",
        "offers": {
          "@type": "Offer",
          "priceSpecification": {
            "@type": "PriceSpecification",
            "priceCurrency": "TRY"
          }
        }
      },
      {
        "@type": "Service",
        "name": "Beslenme Danışmanlığı",
        "offers": {
          "@type": "Offer",
          "priceSpecification": {
            "@type": "PriceSpecification",
            "priceCurrency": "TRY"
          }
        }
      }
    ],
    "description": "Diyetisyen Nihal Kamış'tan kişiye özgü diyet planları, beslenme danışmanlığı ve sağlıklı yaşam rehberleri.",
    "founder": {
      "@type": "Person",
      "name": "Nihal Kamış",
      "jobTitle": "Diyetisyen",
      "alumniOf": {
        "@type": "CollegeOrUniversity",
        "name": "İstanbul Medipol Üniversitesi"
      }
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5",
      "reviewCount": "100" // Placeholder - update with actual reviews
    },
    "sameAs": [
      "https://www.instagram.com/nihalkamis",
      "https://www.facebook.com/nihalkamis"
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(businessSchema)}
      </script>
    </Helmet>
  );
};

export default BusinessSchema;